import { createContext, useContext, useEffect, useState } from "react";
import { basePath } from "../components/config";
import { useAuth } from "./auth";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";

export const TabStateContext = createContext(null);
export const TabUpdateContext = createContext(null);
const apiDataFetchList = [
  "getLabel",
  "getCores",
  "getPapers",
  "getPaperSizes",
  "getColors",
  "getUps",
];

export function TabProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabValue = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(parseInt(tabValue) || 0);
  const [{ activeUser }] = useAuth();
  const [tabData, setTabData] = useState(null);
  const [teethList, setTeethList] = useState(null);
  // console.log({ tabData });
  const [isShowPagination, setIsShowPagination] = useState(true);

  useEffect(() => {
    setTabData(null);
    const restApi = apiDataFetchList[activeTab] || "/404";

    (async () => {
      try {
        const res = await fetch(basePath + restApi, {
          method: "post",
          headers: {
            Authorization: `Bearer ${activeUser?.remember_token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();

        if (res.status === 401) {
          document.cookie =
            "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          toast.error(data.message);
        }

        if (data.status) {
          setTabData(JSON.parse(data.data));
          if (data?.teethList) {
            setTeethList(JSON.parse(data.teethList));
          }
        } else {
          setTabData(null);
        }
      } catch (error) {
        setTabData(null);
        console.error("TabProvider:: api calling fail =>", error);
      }
    })();
  }, [activeTab]);

  const state = { activeTab, tabData, isShowPagination, teethList };
  const updateFns = {
    setActiveTab,
    setTabData,
    setIsShowPagination,
    setTeethList,
  };

  return (
    <TabStateContext.Provider value={state}>
      <TabUpdateContext.Provider value={updateFns}>
        {children}
      </TabUpdateContext.Provider>
    </TabStateContext.Provider>
  );
}

export function useTab() {
  const state = useContext(TabStateContext);
  const updateFns = useContext(TabUpdateContext);
  return [state, updateFns];
}
